import { Enum } from '../commons/common';

interface Bank {
    code: string;
    name: string;
}

export interface BankAccountStatementType {
    sourceIBan: string;
    bankName: string;
    description: string;
    amount: number;
    date: string;
    cardNumber?: string;
    additionalInformation: string;
    transferType: Enum;
    type: Enum;
    chargeStatus: Enum;
    id: string;
    trackingCode?: string;
}

export interface BankAccountStatementCreate {
    amount: string;
    sourceIBan: string;
    bankName: Enum;
    date: string;
    cardNumber: string;
    description: string;
    transferType: Enum;
    additionalInformation: string;
    key: string;
}

export interface BankAccountStatementCreateBody {
    amount: number;
    sourceIBan: string;
    bankName: string;
    date: string;
    cardNumber: string;
    description: string;
    transferType: string;
    additionalInformation: string;
    key: string;
}

export enum BankAccountStatementChargeStatus {
    NotProcessed,
    WaitingForConfirmation,
    Done,
}
